import React, { Component } from 'react';
import ResultCard from './ResultCard';
import { groupBy, map, startCase } from 'lodash';


export default class ResultsComponents extends Component {
  renderResultCardByGroup(groupData, groupName){
    const groupNameFormated = startCase(groupName.split("_").join(" "));
    return (
      <div className="result-category">
        <h4>{groupData.length} {groupNameFormated}</h4>
        {map(groupData, (resultData, key) => {
          return (
            <ResultCard router={this.props.router} resultData={resultData} key={key} />
          );
        })}
      </div>
    );
  }
  renderResults(results){
    const resultsGroup = groupBy(results, 'requeststatus.displayname');
    const resultsGroupView =  map(resultsGroup, (groupData, key) => {
      return this.renderResultCardByGroup(groupData, key);
    });
    return resultsGroupView;
  }
  render() {
    const resultListView = this.renderResults(this.props.resultList);
    return (
      <div>
        {resultListView}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results/ResultsComponents.jsx